module.exports = __webpack_public_path__ + "img/new_25.af0440a7.jpg";